import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import XLSX_STYLE from 'xlsx-js-style';
import ExportExcelNormalTemplate from './ExportExcelNormalTemplate';
import ExportExcelMonthlyTemplate from './ExportExcelMonthlyTemplate';

export default {
    computed: {
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
        }),
    },
    methods: {
        async onExport() {
            const wb = XLSX_STYLE.utils.book_new();
            const ws = await this.getExcelSheet();

            XLSX_STYLE.utils.book_append_sheet(wb, ws, '綜合損益表');
            XLSX_STYLE.writeFile(wb, `${moment(+this.queryParams.StartDate).format('YYYY-MM-DD')}～${moment(+this.queryParams.EndDate).format('YYYY-MM-DD')}綜合損益表.xlsx`);
        },
        async getExportDataRows() {
            const details = this.displayMode === 1 ? this.tableData : this.monthlyTableData;
            const rows = [];
            const rowDivider = [];

            // rows.push(['會計項目', '金額', '合計金額', '佔營收％']);

            const GRAY_LIST = [0, 2, 3, 4, 7, 9, 10, 13];
            if (this.displayMode === 1) {
                details.forEach((item, i) => {
                    const COLOR = GRAY_LIST.includes(i) ? 'd9d9d9' : 'fdeba8';
                    rows.push([
                        `${COLOR}#@#${item.name}`, //
                        '',
                        i ? item.amount : '',
                        i ? `${this.percentageText(item.percentage)} %` : '',
                    ]);

                    item.children.forEach((child) => {
                        rows.push([
                            `        ${child.name}`, //
                            child.amount,
                            '',
                            `${this.percentageText(child.percentage)} %`,
                        ]);
                    });
                });
            } else {
                details.forEach((item, i) => {
                    const COLOR = GRAY_LIST.includes(i) ? 'd9d9d9' : 'fdeba8';
                    const AMOUNT = [];
                    for (let m = 1; m <= 12; m += 1) {
                        AMOUNT.push(i ? item[`amount-m${m}`] || 0 : '');
                    }
                    AMOUNT.push(item.amount || 0);
                    rows.push([
                        `${COLOR}#@#${item.name}`, //
                        ...AMOUNT,
                    ]);

                    item.children.forEach((child) => {
                        const CHILD_AMOUNT = [];
                        for (let m = 1; m <= 12; m += 1) {
                            CHILD_AMOUNT.push(child[`amount-m${m}`] || 0);
                        }
                        CHILD_AMOUNT.push(child.amount || 0);
                        rows.push([
                            `        ${child.name}`, //
                            ...CHILD_AMOUNT,
                        ]);
                    });
                });
            }

            return { rows, rowDivider };
        },
        async getExcelSheet() {
            const { rows, rowDivider } = await this.getExportDataRows();
            const sheet = _.cloneDeep(this.displayMode === 1 ? ExportExcelNormalTemplate : ExportExcelMonthlyTemplate);

            XLSX_STYLE.utils.sheet_add_aoa(sheet, rows, { origin: 'A4' });

            // eslint-disable-next-line no-unreachable
            const widthSettings = this.displayMode === 1 ? [30, 15, 15, 15] : [30, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15];
            // 設定全部欄寬 (由bodyHeader定義，預設 15)
            sheet['!cols'] = _.map(widthSettings, (h) => ({ wch: h }));
            sheet['!rows'] = [{ hpx: 70 }, { hpx: 25 }];

            let color;
            _.forEach(sheet, (value, key) => {
                if (!key.includes('!')) {
                    // 'B13' => COL: 'B', ROW: '13'
                    const isLetterSingle = !Number.isNaN(Number(key.substring(1)));
                    const COL = isLetterSingle ? key.substring(0, 1) : key.substring(0, 2);
                    const ROW = isLetterSingle ? Number(key.substring(1)) : Number(key.substring(2));

                    // 每一格
                    sheet[key].s = {
                        alignment: {
                            horizontal: 'left',
                            vertical: 'bottom',
                        },
                    };

                    // 設定「欄」顏色
                    if (ROW > 3 && COL === 'A') {
                        if (!`${value.v}`.match(/^ {8}/)) {
                            const SPLIT = value.v.split('#@#');
                            const VALUE = _.last(SPLIT);
                            color = _.head(SPLIT);
                            sheet[key].v = VALUE;
                        } else color = null;
                    }

                    if (color) sheet[key].s.fill = { fgColor: { rgb: color } };

                    // 公司名稱標題
                    if (key === 'A1') {
                        sheet[key].s.alignment.horizontal = 'center';
                        sheet[key].s.alignment.vertical = 'center';
                        sheet[key].s.alignment.wrapText = true;

                        sheet[key].v = `${this.companyInfo.cH_CMP}\n綜合損益表`;

                        sheet[key].s.font = {
                            bold: true,
                            sz: 16,
                        };
                    }

                    // 選取區間
                    if (this.displayMode === 1 && key === 'A2') {
                        sheet[key].s.alignment.horizontal = 'left';
                        sheet[key].s.alignment.vertical = 'center';

                        const START_DATE = moment(+this.queryParams.StartDate);
                        const END_DATE = moment(+this.queryParams.EndDate);
                        sheet[key].v = `傳票日期範圍：${START_DATE.year() - 1911}-${START_DATE.format('MM-DD')} 至 ${END_DATE.year() - 1911}-${END_DATE.format('MM-DD')}`;
                    } else if (key === 'A2') {
                        sheet[key].s.alignment.horizontal = 'left';
                        sheet[key].s.alignment.vertical = 'center';

                        sheet[key].v = `傳票日期範圍：${this.queryYear - 1911} 年度`;
                    }

                    // 製表日期
                    if (this.displayMode === 1 && key === 'C2') {
                        sheet[key].s.alignment.horizontal = 'right';
                        sheet[key].s.alignment.vertical = 'center';
                        const TODAY = moment();
                        sheet[key].v = `製表日期：${TODAY.year() - 1911}-${TODAY.format('MM-DD')}`;
                    } else if (key === 'L2') {
                        sheet[key].s.alignment.horizontal = 'right';
                        sheet[key].s.alignment.vertical = 'center';
                        const TODAY = moment();
                        sheet[key].v = `製表日期：${TODAY.year() - 1911}-${TODAY.format('MM-DD')}`;
                    }

                    // 借、貸方金額格式設定
                    if (this.displayMode === 1 && ROW >= 2 && (COL === 'B' || COL === 'C')) {
                        sheet[key].s.alignment.horizontal = 'right';
                        sheet[key].z = '#,##0_-;-#,##0_-;0;General';
                    } else if (
                        ROW >= 2
                        && (COL === 'B'
                            || COL === 'C'
                            || COL === 'D'
                            || COL === 'E'
                            || COL === 'F'
                            || COL === 'G'
                            || COL === 'H'
                            || COL === 'I'
                            || COL === 'J'
                            || COL === 'K'
                            || COL === 'L'
                            || COL === 'M'
                            || COL === 'N')
                    ) {
                        sheet[key].s.alignment.horizontal = 'right';
                        sheet[key].z = '#,##0_-;-#,##0_-;0;General';
                    }

                    if (ROW >= 2 && COL === 'D') sheet[key].s.alignment.horizontal = 'right';

                    // 表頭字體設定
                    if (this.displayMode === 1 && ROW === 3) sheet[key].s.font = { bold: true };
                    else if (ROW === 3) {
                        sheet[key].s.font = { bold: true };
                        if (Number.isInteger(+sheet[key].v)) sheet[key].v = `${+this.queryYear - 1911}年${+sheet[key].v}月`;
                    }

                    // 表頭 ＆ 之後得每一列資料
                    if (ROW >= 3) {
                        sheet[key].s.border = {
                            bottom: { style: 'thin', color: 'FFFFFFFF' },
                            top: { style: 'thin', color: 'FFFFFFFF' },
                            left: { style: 'thin', color: 'FFFFFFFF' },
                            right: { style: 'thin', color: 'FFFFFFFF' },
                        };
                    }

                    // 分隔線設定
                    if (rowDivider.includes(ROW - 3)) sheet[key].s.border.bottom = { style: 'medium', color: 'FFFFFFFF' };
                }
            });

            return sheet;
        },

        percentageText(percentage) {
            if (!percentage.includes) return '--';
            if (percentage.includes('NaN') || percentage.includes('Infinity')) {
                return '--';
            }
            return percentage;
        },
    },
};
